import { useEffect } from "react";
import { useThemeStore } from "@stores/theme.store";

type UsePageHeaderOptions = {
  filter?: boolean;
  image?: boolean;
  leading?: "home" | "back";
  bottomNavigation?: "hidden" | "home" | "marketplace";
  checkout?: boolean;
  shopList?: boolean;
};

export const usePageHeader = (title: string, options: UsePageHeaderOptions = {}) => {
  const { setHeader, setAppBar, setBottomNavigation } = useThemeStore((state) => state);
  const {
    filter = false,
    image = false,
    leading = "back",
    bottomNavigation = "home",
    checkout = false,
    shopList = false,
  } = options;

  useEffect(() => {
    setHeader({ buttonBack: leading !== "home", filter, title, image });
    setAppBar({ title, show: true, leading, checkout, shopList });
    setBottomNavigation(bottomNavigation);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
